/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Delete_LabelInputs */

const en_manual_qc_delete_label = /** @type {(inputs: Manual_Qc_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete issue`)
};

const fr_manual_qc_delete_label = /** @type {(inputs: Manual_Qc_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer l'incident`)
};

const de_manual_qc_delete_label = /** @type {(inputs: Manual_Qc_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem löschen`)
};

const it_manual_qc_delete_label = /** @type {(inputs: Manual_Qc_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina problema`)
};

const ru_manual_qc_delete_label = /** @type {(inputs: Manual_Qc_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить проблему`)
};

const es_manual_qc_delete_label = /** @type {(inputs: Manual_Qc_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar problema`)
};

const zh_cn2_manual_qc_delete_label = /** @type {(inputs: Manual_Qc_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除问题`)
};

const ja_manual_qc_delete_label = /** @type {(inputs: Manual_Qc_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題を削除`)
};

const hi_manual_qc_delete_label = /** @type {(inputs: Manual_Qc_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समस्या हटाएं`)
};

const pt_pt2_manual_qc_delete_label = /** @type {(inputs: Manual_Qc_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir problema`)
};

/**
* | output |
* | --- |
* | "Delete issue" |
*
* @param {Manual_Qc_Delete_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_delete_label = /** @type {((inputs?: Manual_Qc_Delete_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Delete_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_delete_label(inputs)
	if (locale === "de") return de_manual_qc_delete_label(inputs)
	if (locale === "it") return it_manual_qc_delete_label(inputs)
	if (locale === "ru") return ru_manual_qc_delete_label(inputs)
	if (locale === "es") return es_manual_qc_delete_label(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_delete_label(inputs)
	if (locale === "ja") return ja_manual_qc_delete_label(inputs)
	if (locale === "hi") return hi_manual_qc_delete_label(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_delete_label(inputs)
	return en_manual_qc_delete_label(inputs)
});